import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const SortSpan = ({ isHighlighted, onClick, text }) => (
  <span onClick={onClick} className={`sort-container__filter ${isHighlighted && 'sort-container__highlight'}`}>{text}</span>
);

SortSpan.propTypes = {
  isHighlighted: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const SortContainer = ({
  activeIndex,
  setActiveIndex,
}) => (
  <div className="sort-container">
    <span className="sort-container__caption">Сортировать:</span>
    {
      [{ text: 'по дате появления', sort: '' },
        { text: 'по возрастанию цены', sort: 'high' },
        { text: 'по убыванию цены', sort: 'low' }].map((item, i) => (
        <SortSpan
          key={i} // eslint-disable-line
          isHighlighted={i === activeIndex}
          text={item.text}
          onClick={() => {
            setActiveIndex(i);
          }}
        />
      ))
    }
  </div>
);

SortContainer.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  setActiveIndex: PropTypes.func.isRequired,
};

export default SortContainer;



// WEBPACK FOOTER //
// ./src/components/ui/SortContainer/index.js